import {HostApplicationStoreType} from 'hostApplicationStoreType';

type RoutingType = {
    location: {
        pathname: string;
        search: string;
        hash: string;
    };
};

/**
 * Gets the routing information from the Host Application store.
 * @param {HostApplicationStore} store - Host Application store
 * @returns {RoutingType} The routing information including pathname, search, and hash
 */
export const getRouting = (store: HostApplicationStoreType): RoutingType => store.router;
